/* KitKraft — "Colour It In". Tap a crayon, tap a shape. Then "bring it to life"
   and your drawing lights up and moves. 3 pictures. Ages ~3–10. */
(function () {
  "use strict";

  var CRAYONS = ["#ff5a5f", "#ff9f40", "#ffd24a", "#4fd07f", "#4fa3ff", "#b07dff", "#ff86c8", "#8a5a3c"];
  var WHITE = "#ffffff";
  var GLOW = "#ffe27a";

  /* ---- scenes: each returns an <svg> inner string. Regions = shapes with
     class kkcol__rg + data-region + fill #fff (+ their own black stroke). ---- */
  var STROKE = 'stroke="#241f16" stroke-width="3.4" stroke-linejoin="round"';

  function rg(region, body, cls) {
    return '<g class="kkcol__rg ' + (cls || "") + '" data-region="' + region + '">' + body + "</g>";
  }

  var SCENES = [
    {
      name: "Rocket",
      vb: "0 0 300 264",
      msg: "Colour the rocket, then send it up.",
      win: { h: "Blast off! \u{1F680}", p: "You coloured it and it flew. A KitKraft kit works the same way — colour the picture, add the light, switch it on." },
      svg: function () {
        return '' +
          '<rect class="kkcol__rg" data-region="sky" x="0" y="0" width="300" height="238" fill="#eef3ff" stroke="none"/>' +
          rg("star1", '<path d="M46 40l4 10 10 4-10 4-4 10-4-10-10-4 10-4z" fill="#fff" ' + STROKE + '/>', "kkcol__light kkcol__blink") +
          rg("star2", '<path d="M250 60l3 8 8 3-8 3-3 8-3-8-8-3 8-3z" fill="#fff" ' + STROKE + '/>', "kkcol__light kkcol__blink") +
          '<rect class="kkcol__rg" data-region="ground" x="0" y="230" width="300" height="34" fill="#fff" ' + STROKE + '/>' +
          '<g class="kkcol__lift">' +
          rg("flame", '<path d="M126 196q24 46 48 0q-8 34 -24 46q-16 -12 -24 -46z" fill="#fff" ' + STROKE + '/>', "kkcol__light") +
          rg("finL", '<path d="M120 150 L92 206 L120 196 Z" fill="#fff" ' + STROKE + '/>') +
          rg("finR", '<path d="M180 150 L208 206 L180 196 Z" fill="#fff" ' + STROKE + '/>') +
          rg("body", '<rect x="120" y="96" width="60" height="106" rx="14" fill="#fff" ' + STROKE + '/>') +
          rg("nose", '<path d="M150 42 L182 96 L118 96 Z" fill="#fff" ' + STROKE + '/>') +
          rg("window", '<circle cx="150" cy="128" r="16" fill="#fff" ' + STROKE + '/>', "kkcol__light") +
          '</g>';
      }
    },
    {
      name: "Robot",
      vb: "0 0 300 276",
      msg: "Colour the robot, then wake him up.",
      win: { h: "He's alive! \u{1F916}", p: "Eyes on, arms moving — because you finished the picture. That's the KitKraft feeling: build it, and it comes to life." },
      svg: function () {
        return '' +
          '<rect class="kkcol__rg" data-region="bg" x="0" y="0" width="300" height="276" fill="#f2f7ef" stroke="none"/>' +
          '<g class="kkcol__scene kkcol__sway">' +
          '<line x1="150" y1="44" x2="150" y2="70" stroke="#241f16" stroke-width="4"/>' +
          rg("antBall", '<circle cx="150" cy="36" r="9" fill="#fff" ' + STROKE + '/>', "kkcol__light kkcol__blink") +
          rg("head", '<rect x="104" y="70" width="92" height="70" rx="14" fill="#fff" ' + STROKE + '/>') +
          rg("eyeL", '<circle cx="130" cy="102" r="10" fill="#fff" ' + STROKE + '/>', "kkcol__light") +
          rg("eyeR", '<circle cx="170" cy="102" r="10" fill="#fff" ' + STROKE + '/>', "kkcol__light") +
          rg("mouth", '<rect x="126" y="120" width="48" height="9" rx="3" fill="#fff" ' + STROKE + '/>') +
          rg("armL", '<rect x="70" y="150" width="24" height="60" rx="9" fill="#fff" ' + STROKE + '/>') +
          rg("armR", '<rect x="206" y="150" width="24" height="60" rx="9" fill="#fff" ' + STROKE + '/>') +
          rg("torso", '<rect x="112" y="142" width="76" height="76" rx="12" fill="#fff" ' + STROKE + '/>') +
          rg("chest", '<circle cx="150" cy="180" r="12" fill="#fff" ' + STROKE + '/>', "kkcol__light") +
          rg("legL", '<rect x="122" y="218" width="22" height="36" rx="7" fill="#fff" ' + STROKE + '/>') +
          rg("legR", '<rect x="156" y="218" width="22" height="36" rx="7" fill="#fff" ' + STROKE + '/>') +
          '</g>';
      }
    },
    {
      name: "House",
      vb: "0 0 300 250",
      msg: "Colour the house and garden, then turn on the lights.",
      win: { h: "Home sweet home ✨", p: "The lights came on, the smoke curled up — from a picture you coloured. Every paper-circuit kit does exactly this." },
      svg: function () {
        return '' +
          '<rect class="kkcol__rg" data-region="sky" x="0" y="0" width="300" height="210" fill="#eaf3ff" stroke="none"/>' +
          '<g class="kkcol__spin"><g>' +
          '<line x1="52" y1="20" x2="52" y2="4" stroke="#241f16" stroke-width="3"/>' +
          '<line x1="52" y1="66" x2="52" y2="82" stroke="#241f16" stroke-width="3"/>' +
          '<line x1="30" y1="43" x2="14" y2="43" stroke="#241f16" stroke-width="3"/>' +
          '<line x1="74" y1="43" x2="90" y2="43" stroke="#241f16" stroke-width="3"/>' +
          '</g></g>' +
          rg("sun", '<circle cx="52" cy="43" r="18" fill="#fff" ' + STROKE + '/>', "kkcol__light") +
          rg("grass", '<rect x="0" y="204" width="300" height="46" fill="#fff" ' + STROKE + '/>') +
          '<g class="kkcol__sway">' +
          rg("trunk", '<rect x="252" y="150" width="14" height="58" fill="#fff" ' + STROKE + '/>') +
          rg("leaves", '<circle cx="259" cy="140" r="26" fill="#fff" ' + STROKE + '/>') +
          '</g>' +
          '<g class="kkcol__scene">' +
          '<circle class="kkcol__puff" cx="96" cy="70" r="7" fill="#d7d7d7"/>' +
          '<circle class="kkcol__puff" cx="102" cy="58" r="9" fill="#d7d7d7" style="animation-delay:1s"/>' +
          rg("chimney", '<rect x="86" y="66" width="18" height="34" fill="#fff" ' + STROKE + '/>') +
          rg("roof", '<path d="M60 108 L150 52 L240 108 Z" fill="#fff" ' + STROKE + '/>') +
          rg("wall", '<rect x="78" y="106" width="144" height="100" fill="#fff" ' + STROKE + '/>') +
          rg("door", '<rect x="134" y="156" width="32" height="50" fill="#fff" ' + STROKE + '/>') +
          rg("winL", '<rect x="94" y="124" width="26" height="26" fill="#fff" ' + STROKE + '/>', "kkcol__light") +
          rg("winR", '<rect x="182" y="124" width="26" height="26" fill="#fff" ' + STROKE + '/>', "kkcol__light") +
          '</g>' +
          '<g class="kkcol__sway">' +
          '<line x1="34" y1="204" x2="34" y2="180" stroke="#241f16" stroke-width="3"/>' +
          rg("flower", '<circle cx="34" cy="172" r="10" fill="#fff" ' + STROKE + '/>') +
          '</g>';
      }
    }
  ];

  function initOne(root) {
    if (root.dataset.kkcolInit) return;
    root.dataset.kkcolInit = "1";

    var stage = root.querySelector("[data-kkcol-paper]");
    var pal = root.querySelector("[data-kkcol-palette]");
    var pips = root.querySelector("[data-kkcol-pips]");
    var msgEl = root.querySelector("[data-kkcol-msg]");
    var goBtn = root.querySelector("[data-kkcol-go]");
    var redoBtn = root.querySelector("[data-kkcol-redo]");
    var sparkEl = root.querySelector("[data-kkcol-spark]");
    var winH = root.querySelector("[data-kkcol-win-h]");
    var winP = root.querySelector("[data-kkcol-win-p]");
    var winNext = root.querySelector("[data-kkcol-win-next]");
    var winCta = root.querySelector("[data-kkcol-win-cta]");

    // Defensive guard - see kk-sort.js for why (a real "Cannot read properties
    // of null" was seen on the Kit Shelf page, exact game not pinned down).
    if (!stage || !pal || !pips || !msgEl || !goBtn || !redoBtn || !sparkEl ||
        !winH || !winP || !winNext || !winCta) return;

    winCta.textContent = root.getAttribute("data-cta-label") || "See the kits";
    winCta.setAttribute("href", root.getAttribute("data-cta-href") || "#");

    var si = 0, colour = CRAYONS[0], timer = 0, started = false;

    function markStarted() {
      if (started) return;
      started = true;
      try { document.dispatchEvent(new CustomEvent("kk:game-start", { detail: { game: "colour-it" } })); } catch (e) {}
    }

    SCENES.forEach(function () {
      var s = document.createElement("span"); s.className = "kkcol__pip"; pips.appendChild(s);
    });

    // palette
    CRAYONS.forEach(function (c, i) {
      var b = document.createElement("button");
      b.type = "button"; b.className = "kkcol__swatch" + (i === 0 ? " sel" : "");
      b.style.background = c; b.setAttribute("aria-label", "Crayon " + (i + 1));
      b.addEventListener("click", function () { pickColour(c, b); });
      pal.appendChild(b);
    });
    var er = document.createElement("button");
    er.type = "button"; er.className = "kkcol__swatch kkcol__swatch--erase";
    er.setAttribute("aria-label", "Rubber");
    er.addEventListener("click", function () { pickColour(WHITE, er); });
    pal.appendChild(er);

    function pickColour(c, btn) {
      colour = c;
      Array.prototype.forEach.call(pal.children, function (n) { n.classList.remove("sel"); });
      btn.classList.add("sel");
    }

    function build() {
      clearTimeout(timer);
      root.classList.remove("alive", "won");
      var S = SCENES[si];
      msgEl.textContent = S.msg;
      goBtn.textContent = "Bring it to life";
      stage.innerHTML = '<svg class="kkcol__svg" viewBox="' + S.vb + '" xmlns="http://www.w3.org/2000/svg">' + S.svg() + "</svg>";
      Array.prototype.forEach.call(pips.children, function (p, i) {
        p.classList.toggle("on", i < si);
        p.classList.toggle("now", i === si);
      });
      sparkEl.innerHTML = "";
      // wire regions
      Array.prototype.forEach.call(stage.querySelectorAll(".kkcol__rg"), function (g) {
        g.addEventListener("click", function () {
          if (root.classList.contains("alive")) return;
          markStarted();
          Array.prototype.forEach.call(g.querySelectorAll("[fill]"), function (sh) {
            sh.setAttribute("fill", colour);
          });
        });
      });
    }

    function activate() {
      if (root.classList.contains("alive")) return;
      // any light region still white → turn it warm so it visibly lights
      Array.prototype.forEach.call(stage.querySelectorAll(".kkcol__light [fill]"), function (sh) {
        var f = (sh.getAttribute("fill") || "").toLowerCase();
        if (f === WHITE || f === "#fff" || f === "") sh.setAttribute("fill", GLOW);
      });
      // sparkle burst
      sparkEl.innerHTML = "";
      var cols = ["#ff5a5f", "#ffd24a", "#4fa3ff", "#4fd07f", "#b07dff"];
      for (var i = 0; i < 16; i++) {
        var s = document.createElement("i");
        var ang = Math.PI * 2 * i / 16, dist = 60 + Math.random() * 70;
        s.style.left = "50%"; s.style.top = "42%";
        s.style.background = cols[i % cols.length];
        s.style.setProperty("--dx", Math.cos(ang) * dist + "px");
        s.style.setProperty("--dy", Math.sin(ang) * dist + "px");
        sparkEl.appendChild(s);
      }
      root.classList.add("alive");
      msgEl.textContent = "";
      timer = setTimeout(win, 2600);
    }

    function win() {
      root.classList.add("won");
      var last = si === SCENES.length - 1, S = SCENES[si];
      winH.textContent = last ? "You brought them all to life! ⚡" : S.win.h;
      winP.textContent = last
        ? "Colour, add a light, switch it on — you just did the whole thing. Now do it for real."
        : S.win.p;
      winNext.hidden = last;
      winCta.hidden = !last;
      if (last) {
        try { document.dispatchEvent(new CustomEvent("kk:game-won", { detail: { game: "colour-it" } })); } catch (e) {}
      }
    }

    goBtn.addEventListener("click", activate);
    redoBtn.addEventListener("click", build);
    winNext.addEventListener("click", function () { if (si < SCENES.length - 1) { si++; build(); } });

    build();
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll(".kkcol[data-kkcol]"), initOne);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
  window.KKColourIt = { init: boot };
})();
